import { on } from "@ngrx/store";

import { cloneDeep } from "lodash";

import { MutateObjectState } from "../mutate-object/mutate-object.state";

import { JobMutateChargeActions } from "./mutate-charges.actions";
import { EditableExpense } from "./mutate-charges.state";

export const jobMutateChargesReducer = [
  on(JobMutateChargeActions.productAutocompleteInputChanged, (state: MutateObjectState, { value }): MutateObjectState => {

    const currentAmount = state.mutateObjectDialog.mutators.charge.amount;

    const resetAmount = Boolean(state.mutateObjectDialog.mutators.charge.productId);

    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        mutators: {
          ...state.mutateObjectDialog.mutators,
          charge: {
            ...state.mutateObjectDialog.mutators.charge,
            productName: value,
            productId: undefined,
            amount: resetAmount ? undefined : currentAmount,
          }
        }
      }
    }
  }),
  on(JobMutateChargeActions.descriptionInputChanged, (state: MutateObjectState, { value }): MutateObjectState => {
    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        mutators: {
          ...state.mutateObjectDialog.mutators,
          charge: {
            ...state.mutateObjectDialog.mutators.charge,
            description: value,
          }
        }
      }

    }
  }),
  on(JobMutateChargeActions.productWithPriceSelected, (state: MutateObjectState, { selectedProduct, price }): MutateObjectState => {

    const amount = price.priceType === 'percentage' ? price.amount : price.amount / 100;

    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        mutators: {
          ...state.mutateObjectDialog.mutators,
          charge: {
            ...state.mutateObjectDialog.mutators.charge,
            productId: selectedProduct.id,
            productName: selectedProduct.name,
            amount,
          }
        }
      }
    }
  }),
  on(JobMutateChargeActions.percentageAmountInputChanged, (state: MutateObjectState, { amount }): MutateObjectState => {
    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        mutators: {
          ...state.mutateObjectDialog.mutators,
          charge: {
            ...state.mutateObjectDialog.mutators.charge,
            amount,
          }
        }
      }

    }
  }),
  on(JobMutateChargeActions.fixedAmountInputChanged, (state: MutateObjectState, { amount }): MutateObjectState => {
    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        mutators: {
          ...state.mutateObjectDialog.mutators,
          charge: {
            ...state.mutateObjectDialog.mutators.charge,
            amount,
          }
        }
      }

    }
  }),
  on(JobMutateChargeActions.fixedAmountInputBlurred, (state: MutateObjectState): MutateObjectState => {
    return {
      ...state,
    }
  }),
  on(JobMutateChargeActions.quantityInputChanged, (state: MutateObjectState, { quantity }): MutateObjectState => {
    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        mutators: {
          ...state.mutateObjectDialog.mutators,
          charge: {
            ...state.mutateObjectDialog.mutators.charge,
            quantity,
          }
        }
      }
    }
  }),
  on(JobMutateChargeActions.eventSelected, (state: MutateObjectState, { eventIds }): MutateObjectState => {
    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        mutators: {
          ...state.mutateObjectDialog.mutators,
          charge: {
            ...state.mutateObjectDialog.mutators.charge,
            eventIds,
          }
        }
      }
    }
  }),
  on(JobMutateChargeActions.taxesSelectionChanged, (state: MutateObjectState, { taxes }): MutateObjectState => {
    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        mutators: {
          ...state.mutateObjectDialog.mutators,
          charge: {
            ...state.mutateObjectDialog.mutators.charge,
            taxes,
          }
        }
      }
    }
  }),
  on(JobMutateChargeActions.removeTaxButtonClicked, (state: MutateObjectState, { taxId }): MutateObjectState => {
    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        mutators: {
          ...state.mutateObjectDialog.mutators,
          charge: {
            ...state.mutateObjectDialog.mutators.charge,
            taxes: state.mutateObjectDialog.mutators.charge.taxes.filter((tax) => tax.id !== taxId),
          }
        }
      }
    }
  }),
  on(JobMutateChargeActions.addExpenseButtonClicked, (state: MutateObjectState): MutateObjectState => {

    const expenses = cloneDeep(state.mutateObjectDialog.mutators.charge.expenses);

    const newExpense: EditableExpense = {
      expenseId: undefined,
      unitCost: 0,
    }

    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        mutators: {
          ...state.mutateObjectDialog.mutators,
          charge: {
            ...state.mutateObjectDialog.mutators.charge,
            expenses: [ ...expenses, newExpense ],
          }
        }
      }
    }
  }),
  on(JobMutateChargeActions.removeExpenseButtonClicked, (state: MutateObjectState, { index }): MutateObjectState => {

    const expenses = cloneDeep(state.mutateObjectDialog.mutators.charge.expenses);

    expenses.splice(index, 1);

    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        mutators: {
          ...state.mutateObjectDialog.mutators,
          charge: {
            ...state.mutateObjectDialog.mutators.charge,
            expenses,
          }
        }
      }
    }
  }),
  on(JobMutateChargeActions.expenseSelected, (state: MutateObjectState, { expenseId, index }): MutateObjectState => {

    const expenses = cloneDeep(state.mutateObjectDialog.mutators.charge.expenses);

    const expense = expenses[index];

    expense.expenseId = expenseId;

    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        mutators: {
          ...state.mutateObjectDialog.mutators,
          charge: {
            ...state.mutateObjectDialog.mutators.charge,
            expenses,
          }
        }
      }
    }
  }),
  on(JobMutateChargeActions.unitCostInputChanged, (state: MutateObjectState, { unitCost, index }): MutateObjectState => {

    const expenses = cloneDeep(state.mutateObjectDialog.mutators.charge.expenses);

    const expense = expenses[index];

    expense.unitCost = unitCost;

    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        mutators: {
          ...state.mutateObjectDialog.mutators,
          charge: {
            ...state.mutateObjectDialog.mutators.charge,
            expenses,
          }
        }
      }
    }
  }),
];
